import { gql } from 'urql';
import { PRODUCT } from '../client';

export const REQUOTE_PROVIDER_ROUTE = gql`
  mutation ${PRODUCT}RequoteProviderRoute($input: RequoteProviderRouteInput!) {
    requoteProviderRoute(input: $input) {
      route {
        id
        providerDispatch {
          status
          error
        }
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
